module.exports = __webpack_public_path__ + "img/Coleman 48-Quart Performance Cooler.c9be9911.jpg";